export enum EServiceType {
    EVENT = 1,
    ACTIVITY = 2,
    INFORMATION = 3,
    INTEGER_EVENT = 4
}

export function isMobileAppService(en: EServiceType|number|string) {
  return [
    EServiceType.EVENT,
    EServiceType.ACTIVITY,
    EServiceType.INTEGER_EVENT
  ].includes(Number(en))
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/enums/e-service-type.enum.ts